import React from 'react';
import { Link } from 'dva/router';
import { connect } from 'dva';
import styles from './index.css';



class NavTop extends React.Component {
    render() {
        console.log("NavTop cur_path", this.props.cur_path);
        let contactFlag = false;
        if (this.props.cur_path == '/about' && window.location.hash == '#contact') {
            contactFlag = true;
        }
        console.log("NavTop contactFlag", contactFlag);
        return (
            <div className={this.props.top_anim ? styles.top_menu_wrap_style_show : styles.top_menu_wrap_style_hide}>
                <div className={styles.nav_top_box}>
                    <img alt="" src="https://img.cgwrite.cn/qa/up/2508/276281.png" style={{ width: '150px', marginRight: '100px' }} />
                    <ul className={styles.menu}>
                        {this.props.route.map(item => {
                            let isActive = this.props.cur_path === (item.path || item.url);
                            if (contactFlag) {
                                isActive = false;
                            }
                            return <li className={`${styles.menu_item} ${isActive && styles.action}`} key={item.path || item.url}>
                                {item.path
                                    ?
                                    <Link to={item.path}>{item.nav_name}</Link>
                                    :
                                    <a target='_blank' href={item.url}>{item.nav_name}</a>
                                }
                            </li>
                        })}
                    </ul>
                </div>
                <div style={{
                    width: '100px', height: '40px', lineHeight: "40px", marginLeft: '0px', marginTop: '0px',
                    textAlign: 'center', background: "#EAB946", borderRadius: '20px'
                }}><Link to="/about#contact" style={{ fontSize: '18px', color: '#ffffff' }} >联系编辑</Link></div>
            </div>
        );
    }
}

const state_props = state => {
    return {
        cur_path: state.app.path,
    }
}

export default connect(state_props)(NavTop);



// WEBPACK FOOTER //
// ./src/component/nav_top/index.js